









import { Component, Vue } from 'vue-property-decorator';
import TaskProceduresTable from '@/modules/tasks/procedures/components/TaskProceduresTable.vue';
import Card from '@/components/default/Card.vue';

@Component({
  components: {
    TaskProceduresTable,
    Card,
  },
})
export default class TaskProceduresOverviewPage extends Vue {

}
